<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <h3
                class="font-weight-bold"
                v-text="isDeletePage() != true ? 'Notifications' : 'Deleted Notifications'"
              ></h3>
              <section v-if="isDeletePage() != true">
                <v-btn
                  class="mx-2 mb-2"
                  fab
                  x-small
                  color="primary"
                  to="/notifications/create"
                >
                  <v-icon dark> mdi-plus </v-icon>
                </v-btn>
              </section>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="4">
                  <v-text-field
                    solo
                    rounded
                    v-model="filter.search_keyword"
                    label="Search notifications... "
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    @click:clear="
                      (filter.search_keyword = ''), (page = 1), getData()
                    "
                    @keydown.enter="(page = 1), getData()"
                  ></v-text-field>
                </v-col>
                <v-col sm="2">
                  <v-autocomplete
                    solo
                    rounded
                    ref="activeStatus"
                    v-model="filter.is_active"
                    :items="statuses"
                    item-text="text"
                    item-value="value"
                    label="Status"
                    @input="(page = 1), getData()"
                    prepend-inner-icon="mdi-toggle-switch"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col sm="2">
                  <v-autocomplete
                    solo
                    rounded
                    ref="notificationStatus"
                    v-model="filter.status"
                    :items="readStatuses"
                    item-text="text"
                    item-value="value"
                    label="Read Status"
                    @input="(page = 1), getData()"
                    prepend-inner-icon="mdi-email"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col sm="2">
                  <v-autocomplete
                    solo
                    rounded
                    ref="notificationType"
                    v-model="filter.type_id"
                    :items="notificationTypes"
                    item-text="text"
                    item-value="value"
                    label="Type"
                    @input="(page = 1), getData()"
                    prepend-inner-icon="mdi-tag"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col sm="2">
                  <v-autocomplete
                    ref="deletedStatus"
                    solo
                    rounded
                    v-model="filter.show_deleted"
                    :items="deletedStatuses"
                    item-text="text"
                    item-value="value"
                    label="Show"
                    @input="(page = 1), getData()"
                    prepend-inner-icon="mdi-eye"
                    clearable
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title v-if="notifications.length != 0">
              <v-spacer></v-spacer>
              <v-btn
                rounded
                class="primary mx-4"
                @click="generateExcel()"
                v-if="isDeletePage() != true"
              >
                <span v-if="isExcelloading"> Generating Excel... </span>
                <span v-else>Generate Excel</span>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <section v-if="isLoading" style="height: 285px">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
              <v-simple-table
                v-else
                fixed-header
                height="285"
                class="striped-table"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Sr No</th>
                      <th class="text-left">Status</th>
                      <th class="text-left">User</th>
                      <th class="text-left">Type</th>
                      <th class="text-left">Message</th>
                      <th class="text-left">Read Status</th>
                      <th class="text-left">Created By</th>
                      <th class="text-left">Created At</th>
                      <th class="text-right action_th">Action</th>
                    </tr>
                  </thead>
                  <tbody v-if="notifications.length != 0">
                    <tr v-for="(notification, i) in notifications" :key="`notification${i}`">
                      <td style="min-width: 85px">
                        {{ i + 1 }}
                      </td>
                      <td>
                        <v-tooltip bottom v-if="notification.is_active == 1">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="teal"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Active
                            </v-chip>
                          </template>
                          <span>Notification is Active</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="notification.is_active == 0">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Inactive
                            </v-chip>
                          </template>
                          <span>Notification is Inactive</span>
                        </v-tooltip>
                      </td>
                      <td style="min-width: 150px">
                        <div class="font-weight-medium">{{ notification.user ? notification.user.user_name : 'All Users' }}</div>
                      </td>
                      <td>
                        <v-chip
                          small
                          :color="getTypeColor(notification.type_id)"
                          text-color="white"
                        >
                          <v-avatar left>
                            <v-icon size="15">{{ getTypeIcon(notification.type_id) }}</v-icon>
                          </v-avatar>
                          {{ getTypeName(notification.type_id) }}
                        </v-chip>
                      </td>
                      <td style="min-width: 250px">
                        <div class="notification-message">{{ truncateMessage(notification.message, 80) }}</div>
                      </td>
                      <td>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              :color="notification.status ? 'green' : 'orange'"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">
                                  {{ notification.status ? 'mdi-email-open' : 'mdi-email' }}
                                </v-icon>
                              </v-avatar>
                              {{ notification.status ? 'Read' : 'Unread' }}
                            </v-chip>
                          </template>
                          <span>{{ notification.status ? 'Notification has been read' : 'Notification is unread' }}</span>
                        </v-tooltip>
                      </td>
                      <td>
                        {{ notification.created_by ? notification.created_by.user_name : 'N/A' }}
                      </td>
                      <td>{{ formatDate(notification.created_at) }}</td>

                      <td class="text-right">
                        <template v-if="isDeletePage() != true">
                          <v-tooltip bottom v-if="!notification.status">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto mx-1"
                                color="blue"
                                @click="markAsRead(notification.id)"
                              >
                                <v-icon dark> mdi-email-open </v-icon>
                              </v-btn>
                            </template>
                            <span>Mark as read</span>
                          </v-tooltip>
                          <v-tooltip bottom v-if="notification.status">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto mx-1"
                                color="orange"
                                @click="markAsUnread(notification.id)"
                              >
                                <v-icon dark> mdi-email </v-icon>
                              </v-btn>
                            </template>
                            <span>Mark as unread</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="openDeleteDialog(notification)"
                              >
                                <v-icon dark> mdi-delete </v-icon>
                              </v-btn>
                            </template>
                            <span>Delete this notification</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="ml-2"
                                fab
                                x-small
                                color="primary"
                                :to="`/notifications/${encryptIt(notification.id)}`"
                              >
                                <v-icon dark> mdi-pencil </v-icon>
                              </v-btn>
                            </template>
                            <span>Edit this notification</span>
                          </v-tooltip>
                        </template>
                        <template v-else>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="success"
                                @click="Restore_this(notification.id)"
                              >
                                <v-icon dark> mdi-delete-restore </v-icon>
                              </v-btn>
                            </template>
                            <span>Restore this notification</span>
                          </v-tooltip>
                        </template>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="9" class="text-center">
                        <div style="height: 200px">
                          <div class="mt-5">
                            <v-icon size="100" color="grey lighten-1">
                              mdi-bell-outline
                            </v-icon>
                            <p class="mt-5 subtitle-1 grey--text">
                              {{ !notifications.length ? 'No notifications available' : '' }}
                            </p>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-pagination 
                v-if="notifications.length != 0"
                v-model="page" 
                :length="paginationLength"
                @input="getData()"
              ></v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      
      <DeleteConfirmationDialog
        v-model="deleteDialog"
        :item="itemToDelete"
        :loading="deleteLoading"
        @confirm="confirmDelete"
        @cancel="deleteDialog = false"
      />
      
      <!-- Restore Success Dialog Box -->
      <v-dialog v-model="is_restored_notification" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-restore
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Notification restored successfully.</h3>
                      <br />
                      <v-btn color="success" @click="is_restored_notification = false">
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>

<script>
import axios from "@/axios";
import DeleteConfirmationDialog from "@/components/DeleteConfirmationDialog.vue";

export default {
  name: "NotificationListPage",
  components: { DeleteConfirmationDialog },
  data() {
    return {
      notifications: [],
      isLoading: true,
      isExcelloading: false,
      page: 1,
      count: 0,
      rowsPerPage: 10,
      serialNoStarting: 1,
      paginationLength: 0,
      is_deleted_notification: false,
      is_restored_notification: false,
      deleteDialog: false,
      itemToDelete: null,
      deleteLoading: false,
      filter: {
        search_keyword: "",
        is_active: "",
        status: "",
        type_id: "",
        show_deleted: false,
      },
      notificationTypes: [
        { text: "System", value: 1 },
        { text: "User", value: 2 },
        { text: "Order", value: 3 },
        { text: "Payment", value: 4 },
        { text: "Alert", value: 5 },
      ],
      readStatuses: [
        { text: "Read", value: true },
        { text: "Unread", value: false },
      ],
      statuses: [
        {
          id: 0,
          text: "Select Status",
          value: "",
        },
        { id: "ACTIVE", text: "ACTIVE", value: "1" },
        { id: "INACTIVE", text: "INACTIVE", value: "0" },
      ],
      deletedStatuses: [
        { text: "Active Notifications", value: false },
        { text: "Deleted Notifications", value: true },
      ],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      
      // Set default values for filters if they are empty
      this.filter.search_keyword = this.filter.search_keyword || "";
      this.filter.is_active = this.filter.is_active || "";
      this.filter.status = this.filter.status || "";
      this.filter.type_id = this.filter.type_id || "";
      this.filter.show_deleted = this.filter.show_deleted || false;
      
      let query = 
        "page=" + this.page +
        "&rowsPerPage=" + this.rowsPerPage +
        "&show_deleted=" + this.filter.show_deleted +
        "&is_active=" + this.filter.is_active +
        "&status=" + this.filter.status +
        "&type_id=" + this.filter.type_id +
        "&search_keyword=" + this.filter.search_keyword;
      
      await axios
        .get(`notifications?${query}`)
        .then((response) => {
          this.notifications = response.data.data.data || response.data.data;
          this.count = response.data.count;
          this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
          this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
        })
        .catch(function (error) {
          console.log(error);
          if (error.response && error.response.status === 401) {
            window.location.href = "/auth/login";
          }
        });
      this.isLoading = false;
    },

    openDeleteDialog(item) {
      this.itemToDelete = item;
      this.deleteDialog = true;
    },
    async confirmDelete() {
      this.deleteLoading = true;
      try {
        await axios.post(`/notifications/delete/${this.encryptIt(this.itemToDelete.id)}`);
        this.deleteDialog = false;
        this.itemToDelete = null;
        this.getData();
      } catch (error) {
        console.log(error);
      }
      this.deleteLoading = false;
    },
    async Delete_this(id) {
      await axios
        .post(`/notifications/delete/${this.encryptIt(id)}`)
        .then(() => {
          this.is_deleted_notification = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    
    async Restore_this(id) {
      await axios
        .post(`/notifications/restore/${this.encryptIt(id)}`)
        .then(() => {
          this.is_restored_notification = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    async markAsRead(id) {
      await axios
        .post(`/notifications/${this.encryptIt(id)}/mark-read`)
        .then(() => {
          this.getData();
          this.$store.dispatch("errors/setSuccess", {
            message: "Notification marked as read",
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    async markAsUnread(id) {
      await axios
        .post(`/notifications/${this.encryptIt(id)}/mark-unread`)
        .then(() => {
          this.getData();
          this.$store.dispatch("errors/setSuccess", {
            message: "Notification marked as unread",
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    async generateExcel() {
      this.isExcelloading = true;
      
      let query = 
        "show_deleted=" + this.filter.show_deleted +
        "&is_active=" + this.filter.is_active +
        "&status=" + this.filter.status +
        "&type_id=" + this.filter.type_id +
        "&search_keyword=" + this.filter.search_keyword;
        
      await axios
        .get(`notifications/excel?${query}`, { responseType: 'blob' })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          const fileName = `notifications_export_${new Date().toISOString().split('T')[0]}.xlsx`;
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
          link.remove();
        })
        .catch(function (error) {
          console.log(error);
        });
      this.isExcelloading = false;
    },

    isDeletePage() {
      return this.filter.show_deleted === true;
    },

    formatDate(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      return date.toLocaleDateString() + " " + date.toLocaleTimeString();
    },

    getTypeName(typeId) {
      const type = this.notificationTypes.find(t => t.value === typeId);
      return type ? type.text : 'Unknown';
    },

    getTypeColor(typeId) {
      const colors = {
        1: 'blue',     // System
        2: 'green',    // User
        3: 'orange',   // Order
        4: 'purple',   // Payment
        5: 'red'       // Alert
      };
      return colors[typeId] || 'grey';
    },

    getTypeIcon(typeId) {
      const icons = {
        1: 'mdi-cog',              // System
        2: 'mdi-account',          // User
        3: 'mdi-cart',             // Order
        4: 'mdi-credit-card',      // Payment
        5: 'mdi-alert'             // Alert
      };
      return icons[typeId] || 'mdi-bell';
    },

    truncateMessage(message, maxLength) {
      if (!message) return '';
      if (message.length <= maxLength) return message;
      return message.substring(0, maxLength) + '...';
    },
  },
};
</script>

<style scoped>
.action_th {
  min-width: 120px !important;
}

.striped-table {
  background: transparent;
}

.striped-table tr:nth-child(even) {
  background-color: #f5f5f5;
}

.v-card-title h3 {
  font-size: 1.5rem;
}

.notification-message {
  line-height: 1.4;
  word-wrap: break-word;
}
</style>